module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<a\n    ng-class="[ctrl.mobile ? \'mapbs-applicationlink-container-mobile\' : \'mapbs-applicationlink-container\', ctrl.active ? \'mapbs-applicationlink-container-active\' : \'\']"\n    ng-href="{{ctrl.getUrl()}}"\n    target="_blank"\n    ng-click="ctrl.logging(\'applications\', ctrl.title)"\n>\n    <div class="mapbs-applicationlink-title">{{ctrl.title}}</div>\n    <div class="mapbs-applicationlink-description">\n        <small>{{ctrl.description}}</small>\n    </div>\n</a>\n';

}
return __p
}